module.exports = __webpack_public_path__ + "static/media/bieffe.2101bee8.png";